// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icloud-ui-group-search .osui-input-search-icon{color:var(--color-gray-7)}.icloud-ui-group-input .ant-input-group-addon{text-align:inherit}.icloud-ui-group-input .ant-select-arrow{right:8px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
